import tw, { styled } from 'twin.macro';

export const StyledLine = styled.span`
  ${tw`block`}
  ${tw`h-[2px] w-[25px]`}
  ${tw`bg-primary-p1`}
  ${tw`my-[6px] mx-auto`}
  ${tw`transition-transform ease-in-out duration-300`}
`;

export const StyledHamburgerButton = styled.button<{ isActive: boolean }>`
  ${tw`lg:hidden`}
  ${tw`p-[10px]`}

  ${StyledLine}:nth-of-type(1) {
    ${({ isActive }) => isActive && tw`translate-y-[8px] rotate-[45deg]`}
  }

  ${StyledLine}:nth-of-type(2) {
    ${({ isActive }) => isActive && tw`opacity-0`}
  }

  ${StyledLine}:nth-of-type(3) {
    ${({ isActive }) => isActive && tw`translate-y-[-8px] rotate-[-45deg]`}
  }
`;

export const StyledSRText = styled.span`
  ${tw`sr-only`};
`;
